module.exports = __webpack_public_path__ + "img/289.1bcb1cba.jpg";